// src/components/weather/weatherUtils.js

export const getWeatherIconUrl = (iconCodeOrUrl, size = 2) => {
  if (!iconCodeOrUrl) return '';
  // NWS provides full URLs — pass through
  if (iconCodeOrUrl.startsWith('http')) return iconCodeOrUrl;
  // Legacy fallback
  return `https://openweathermap.org/img/wn/${iconCodeOrUrl}@${size}x.png`;
};

export const getConditionGradient = (iconCode) => {
  if (!iconCode) return 'linear-gradient(135deg, #333333, #444444)';
  const base = iconCode.replace(/[dn]$/, '');
  const isNight = iconCode.endsWith('n');

  const gradients = {
    '01': isNight
      ? 'linear-gradient(135deg, #0d1b2a, #1b2838)'
      : 'linear-gradient(135deg, #F69620, #FFD93D)',
    '02': isNight
      ? 'linear-gradient(135deg, #1a237e, #283593)'
      : 'linear-gradient(135deg, #4a6fa5, #7facd6)',
    '03': 'linear-gradient(135deg, #546e7a, #78909c)',
    '04': 'linear-gradient(135deg, #455a64, #607d8b)',
    '09': 'linear-gradient(135deg, #1565c0, #42a5f5)',
    '10': isNight
      ? 'linear-gradient(135deg, #0d47a1, #1565c0)'
      : 'linear-gradient(135deg, #1976d2, #64b5f6)',
    '11': 'linear-gradient(135deg, #263238, #455a64)',
    '13': 'linear-gradient(135deg, #b0bec5, #cfd8dc)',
    '50': 'linear-gradient(135deg, #607d8b, #90a4ae)',
  };

  return gradients[base] || 'linear-gradient(135deg, #333333, #555555)';
};

export const getConditionAccent = (iconCode) => {
  if (!iconCode) return '#F69620';
  const base = iconCode.replace(/[dn]$/, '');

  const accents = {
    '01': '#FFD93D', '02': '#7facd6', '03': '#90a4ae', '04': '#78909c',
    '09': '#42a5f5', '10': '#64b5f6', '11': '#78909c', '13': '#e3f2fd', '50': '#b0bec5',
  };

  return accents[base] || '#F69620';
};

export const getDayName = (input) => {
  // Accept unix timestamp (number) or ISO date string
  const date = typeof input === 'number' ? new Date(input * 1000) : new Date(input);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const dateOnly = new Date(date);
  dateOnly.setHours(0, 0, 0, 0);

  if (dateOnly.getTime() === today.getTime()) return 'Today';

  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  if (dateOnly.getTime() === tomorrow.getTime()) return 'Tomorrow';

  return date.toLocaleDateString('en-US', { weekday: 'short' });
};

export const formatDate = (input) => {
  const date = typeof input === 'number' ? new Date(input * 1000) : new Date(input);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

export const roundTemp = (temp) => Math.round(temp);

export const getWindDirection = (deg) => {
  if (typeof deg === 'string') return deg; // NWS already provides "SW", "N", etc.
  const directions = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
  return directions[Math.round(deg / 45) % 8];
};

export const getRainTimingLabel = (timing) => {
  const labels = {
    all_day: 'All Day',
    day: 'Day',
    night: 'Night',
    none: null,
  };
  return labels[timing] || null;
};

export const getRainTimingColor = (timing) => {
  const colors = {
    all_day: '#1565c0',
    day: '#42a5f5',
    night: '#5c6bc0',
    none: 'transparent',
  };
  return colors[timing] || 'transparent';
};
